<template>
  <footer class="footer bg-light">
      <div class="container">
        <div class="row">
            <div class="col-md-12 p-3">
                <p class=" text-center mt-3">All rights reserved by BICM</p>
            </div>
        </div>
      </div>
    </footer>
</template>

<script>
export default {

}
</script>

<style>

</style>